import { render, staticRenderFns } from "./ausschreibung.vue?vue&type=template&id=941065f0&"
import script from "./ausschreibung.vue?vue&type=script&lang=js&"
export * from "./ausschreibung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports